import { render, staticRenderFns } from "./CalendarEventForm.vue?vue&type=template&id=73a8fef0&scoped=true&lang=pug&"
import script from "./CalendarEventForm.vue?vue&type=script&lang=js&"
export * from "./CalendarEventForm.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventForm.vue?vue&type=style&index=0&id=73a8fef0&lang=scss&scoped=true&"
import style1 from "./CalendarEventForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a8fef0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFlex,VLayout,VSpacer,VTextarea})
